import cytoscape from 'cytoscape';

function initMindMap() {
  console.log('Mind map show page loaded');
  const mindMapElement = document.getElementById('mind-map');
  console.log('Mind map element:', mindMapElement);
  if (!mindMapElement) return;

  const mapId = mindMapElement.dataset.mapId;
  console.log('Map ID:', mapId);
  const mapData = JSON.parse(mindMapElement.dataset.map);
  const nodesData = JSON.parse(mindMapElement.dataset.nodes);
  console.log('Nodes data:', nodesData);

  const nodesApiPath = `/member/mind_maps/${mapId}/nodes`;

  // CSRFトークンの取得
  const getCsrfToken = () => {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta ? meta.content : '';
  };

  // Cytoscapeの初期化
  const cy = cytoscape({
    container: mindMapElement,

    elements: {
      nodes: nodesData.map(node => ({
        data: {
          id: node.id.toString(),
          label: node.text,
          parent_node_id: node.parent_node_id ? node.parent_node_id.toString() : null,
          color: node.color || '#667eea'
        },
        position: {
          x: node.x || 100,
          y: node.y || 100
        }
      })),
      edges: nodesData
        .filter(node => node.parent_node_id)
        .map(node => ({
          data: {
            id: `edge-${node.parent_node_id}-${node.id}`,
            source: node.parent_node_id.toString(),
            target: node.id.toString()
          }
        }))
    },

    style: [
      {
        selector: 'node',
        style: {
          'background-color': 'data(color)',
          'color': '#fff',
          'label': 'data(label)',
          'text-valign': 'center',
          'text-halign': 'center',
          'font-size': '14px',
          'padding': '10px',
          'shape': 'roundrectangle',
          'border-width': 2,
          'border-color': '#5a67d8',
          'width': 'label',
          'height': 'label',
          'min-width': '80px',
          'min-height': '40px',
          'text-wrap': 'wrap',
          'text-max-width': '150px'
        }
      },
      {
        selector: 'edge',
        style: {
          'width': 2,
          'line-color': '#a0aec0',
          'target-arrow-color': '#a0aec0',
          'target-arrow-shape': 'triangle',
          'curve-style': 'bezier'
        }
      },
      {
        selector: ':selected',
        style: {
          'background-color': '#5a67d8',
          'border-color': '#4c51bf',
          'border-width': 3,
          'line-color': '#667eea',
          'target-arrow-color': '#667eea'
        }
      }
    ],

    layout: {
      name: 'preset'
    },

    // インタラクティブ機能
    userZoomingEnabled: true,
    userPanningEnabled: true,
    boxSelectionEnabled: true,
    autounselectify: false,
    wheelSensitivity: 0.2
  });

  // 背景をダブルクリックでノード追加
  cy.on('dblclick', function(event) {
    console.log('Double click event:', event);
    if (event.target === cy) { // 背景がクリックされた場合
      const position = event.position;
      console.log('Adding node at:', position);
      addNewNode(position.x, position.y);
    }
  });

  // ノードをドラッグしたら位置を保存
  cy.on('dragfree', 'node', function(event) {
    const node = event.target;
    updateNodePosition(node);
  });

  // ノードをクリックして選択（2つ選択するとエッジ作成）
  let selectedNode = null;
  cy.on('tap', 'node', function(event) {
    const node = event.target;
    
    if (selectedNode && selectedNode !== node) {
      // 2つのノードが選択されたらエッジを作成
      createEdge(selectedNode, node);
      selectedNode = null;
    } else {
      selectedNode = node;
    }
  });

  // 背景をクリックしたら選択を解除
  cy.on('tap', function(event) {
    if (event.target === cy) {
      selectedNode = null;
      cy.elements().unselect();
    }
  });

  // 新しいノードを追加する関数
  async function addNewNode(x, y) {
    console.log('addNewNode called with x:', x, 'y:', y);
    const text = prompt('ノードのテキストを入力してください：', '新しいノード');
    console.log('User input text:', text);
    if (!text) return;

    try {
      console.log('Sending request to:', nodesApiPath);
      const response = await fetch(nodesApiPath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({
          mind_map_node: {
            text: text,
            x: x,
            y: y,
            color: '#667eea'
          }
        })
      });

      console.log('Response status:', response.status);
      if (!response.ok) {
        throw new Error('ノードの作成に失敗しました');
      }

      const newNode = await response.json();
      console.log('New node data:', newNode);
      
      // Cytoscapeにノードを追加
      cy.add({
        group: 'nodes',
        data: {
          id: newNode.id.toString(),
          label: newNode.text,
          color: newNode.color || '#667eea'
        },
        position: {
          x: newNode.x,
          y: newNode.y
        }
      });
      console.log('Node added to Cytoscape');
    } catch (error) {
      console.error('Error adding node:', error);
      alert('ノードの作成に失敗しました');
    }
  }

  // ノードの位置を更新する関数
  async function updateNodePosition(node) {
    const nodeId = node.id();
    const position = node.position();

    try {
      const response = await fetch(`${nodesApiPath}/${nodeId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({
          mind_map_node: {
            x: position.x,
            y: position.y
          }
        })
      });

      if (!response.ok) {
        throw new Error('ノードの更新に失敗しました');
      }
    } catch (error) {
      console.error('Error updating node:', error);
    }
  }

  // エッジを作成する関数（親子関係を設定）
  async function createEdge(sourceNode, targetNode) {
    const sourceId = sourceNode.id();
    const targetId = targetNode.id();

    try {
      // まずターゲットノードの親を更新
      const response = await fetch(`${nodesApiPath}/${targetId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCsrfToken()
        },
        body: JSON.stringify({
          mind_map_node: {
            parent_node_id: sourceId
          }
        })
      });

      if (!response.ok) {
        throw new Error('エッジの作成に失敗しました');
      }

      // Cytoscapeにエッジを追加（既に存在する場合は追加しない）
      const existingEdge = cy.edges(`edge-${sourceId}-${targetId}`);
      if (existingEdge.empty()) {
        cy.add({
          group: 'edges',
          data: {
            id: `edge-${sourceId}-${targetId}`,
            source: sourceId,
            target: targetId
          }
        });
      }
      
      // ターゲットノードのデータを更新
      targetNode.data('parent_node_id', sourceId);
    } catch (error) {
      console.error('Error creating edge:', error);
      alert('エッジの作成に失敗しました');
    }
  }
}

// TurbolinksとTurboの両方のイベントをリッスン
document.addEventListener('turbolinks:load', initMindMap);
document.addEventListener('turbo:load', initMindMap);
